export default __webpack_public_path__ + "static/media/img-slider-cmbus-6.9cb35598.png";